import { render, staticRenderFns } from "./MenuSuperSchool.vue?vue&type=template&id=8f7e1b5a&scoped=true"
import script from "./MenuSuperSchool.vue?vue&type=script&lang=js"
export * from "./MenuSuperSchool.vue?vue&type=script&lang=js"
import style0 from "./MenuSuperSchool.vue?vue&type=style&index=0&id=8f7e1b5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7e1b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f7e1b5a')) {
      api.createRecord('8f7e1b5a', component.options)
    } else {
      api.reload('8f7e1b5a', component.options)
    }
    module.hot.accept("./MenuSuperSchool.vue?vue&type=template&id=8f7e1b5a&scoped=true", function () {
      api.rerender('8f7e1b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/MenuSuperSchool.vue"
export default component.exports